exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dark-red[data-v-a23099b6] {\n  color: #A5030B;\n}\n.dark-green[data-v-a23099b6] {\n  color: #007516\n}\n.bg-washed-red[data-v-a23099b6] {\n  background-color: #FFEBEB;\n}\n.bg-washed-green[data-v-a23099b6] {\n  background-color: #F0FFF4;\n}\n.font-responsive[data-v-a23099b6] {\n  font-size: 18px;\n}\n.margin-fixed[data-v-a23099b6] {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n@media (max-width: 768px) {\n.font-responsive[data-v-a23099b6] {\n  font-size: 14px;\n}\n.margin-fixed[data-v-a23099b6] {\n  margin-left: 0;\n  margin-right: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a23099b6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Alert.vue
// module id = 1351
// module chunks = 0